import React from 'react'
import PropTypes from 'prop-types'

const UndefinedParagraph = ({ type }) => {
  return <div />
}

UndefinedParagraph.propTypes = {
  type: PropTypes.string.isRequired,
}

export default UndefinedParagraph
